import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Outlet, useParams } from "react-router-dom";
import { API_URL } from "../config";
import { authFetch } from "../utils/authFetch";
import { AuthLayout } from "./AuthLayout";



export default function MainUserSide() {
  const [status, setStatus] = useState('checking');
  const [userType, setUserType] = useState('user');
  const [userData, setUserData] = useState(null);
  const [moderatorData, setModeratorData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const { lang = 'ru' } = useParams(); 

  // 0) Инициал: если есть token в URL или в localStorage — считаем, что проверяем, иначе гость
  useEffect(() => {
    const hasUrlToken = !!searchParams.get('token');
    const hasLS = !!localStorage.getItem('token');
    setStatus(hasUrlToken || hasLS ? 'checking' : 'guest');
  }, []); // один раз

  const goLang = (path, opts) =>{
    navigate(`/${lang}${path.startsWith('/') ? '' : '/'}${path}`, opts);}
    

  const goAccount = (isMod) => {
    goLang(`/account${isMod ? '/moderator' : ''}`, { replace: true });
  };

  // 1) Обработка токена из URL
  useEffect(() => {
    const token = searchParams.get('token');
    const name  = searchParams.get('name');
    const email = searchParams.get('email');

    if (!token) return;

    localStorage.setItem('token', token);
    // refreshToken по желанию
    setSearchParams({}); // очищаем URL

    const isMod = email === 'admin@mail.com';
    setUserType(isMod ? 'moderator' : 'user');

    if (isMod) setModeratorData({ name: name || 'Администратор', email, phone: '' });
    else setUserData({ name, email, phone: '' });

    setStatus('authed');
    goAccount(isMod);
  }, [searchParams, setSearchParams]);

  // 2) Проверка сессии из localStorage, если нет токена в URL
  useEffect(() => {
    if (status !== 'checking' || searchParams.get('token')) return;

    const token = localStorage.getItem('token');
    if (!token) {
      setStatus('guest');
      return;
    }

    authFetch(`${API_URL}/about-user`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(async (res) => {
        if (!res.ok) throw res;
        return res.json();
      })
      .then((profile) => {
        const isMod = profile.email === 'admin@mail.com';
        setUserType(isMod ? 'moderator' : 'user');

        if (isMod) {
          setModeratorData({ name: profile.name, email: profile.email, phone: profile.phone });
        } else {
          setUserData({ name: profile.name, email: profile.email, phone: profile.phone });
        }
        setStatus('authed');
        goAccount(isMod);
      })
      .catch(async (err) => {
        // 401/403/сеть — переводим в guest и НЕ делаем navigate('/login') тут
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        setStatus('guest');
      });
  }, [status, searchParams]);

  const handleAuth = (user) => {
    // коллбек из <AuthLayout/> после логина/регистрации
    if (!user) return;
    const isMod = user.email === 'admin@mail.com';
    setUserType(isMod ? 'moderator' : 'user');
    if (isMod) setModeratorData(user);
    else setUserData(user);
    setStatus('authed');
    goAccount(isMod);
  };

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try {
      await authFetch(`${API_URL}/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
      });
    } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    setUserData(null);
    setModeratorData(null);
    setUserType('user');
    setStatus('guest'); // просто покажем логин, без отдельного navigate
  };

  // ===== РЕНДЕР =====

  if (status === 'checking') {
    // скелетон/лоадер вместо мигания формы логина
    return <div className="min-h-[50vh] grid place-items-center text-gray-500">Загрузка…</div>;
  }

  if (status === 'guest') {
    return <AuthLayout onAuth={handleAuth} />;
  }

  // authed
  if (userType === 'moderator') {
    return <Outlet context={{ onLogout: handleLogout, moderatorData, onUpdateModeratorData: setModeratorData }} />;
  }
  return <Outlet context={{ onLogout: handleLogout, userData, onUpdateUserData: setUserData }} />;
}
